import React, { useState } from 'react';
import { Section, OnVisible } from 'components';
import * as styles from './styles.module.scss';

const FaqAccordion = (props) => {
  const { data } = props;
  const { primary, items } = data;
  const {
    is_two_cols: isTwoCols,
    description,
    title,
    do_not_generate_schema: noSchema,
    light_background: lightBg,
  } = primary;
  const titleHtml = title?.html;
  const descriptionHtml = description?.html;
  const colsClass = isTwoCols ? styles.twoColumns : '';

  const [activeIndex, setActiveIndex] = useState([0]);

  const handleOnClick = (event, index) => {
    event.preventDefault();
    setActiveIndex((prevIndexes) => {
      if (prevIndexes.includes(index)) {
        return prevIndexes.filter((prevIndex) => prevIndex !== index);
      }
      return [...prevIndexes, index];
    });
  };

  const escapeDoubleQuotes = (str) => str.replace(/\\([\s\S])|(")/g, '\\$1$2');

  const schema = `
  <script type="application/ld+json">
    {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      ${items.map(
        (item) => `
        {
          "@type": "Question",
          "name": "${item.question?.text}",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "${escapeDoubleQuotes(item.answer?.html)}"
          }
        }`
      )}]
    }
    </script>
  `;

  return (
    <Section
      sliceName="FaqAccordion"
      className={`${styles.faqAccordion} ${colsClass} ${lightBg ? styles.lightBg : ''} faq-accordion`}
      containerClassName={styles.accordionContainer}
    >
      <OnVisible className={styles.textContainer} visibleClassName={styles.visible}>
        {titleHtml && <div className={styles.title} dangerouslySetInnerHTML={{ __html: titleHtml }} />}
        {descriptionHtml && (
          <div className={styles.description} dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
        )}
      </OnVisible>

      <OnVisible className={styles.accordionItems} visibleClassName={styles.visible}>
        {items.map((item, index) => {
          const { question, answer } = item;
          const questionText = question?.text;
          const answerHtml = answer?.html;
          const isActive = activeIndex.includes(index);

          return (
            <div
              key={questionText}
              className={`${styles.accordionItem} ${isActive ? styles.active : styles.inactive}`}
              aria-hidden="true"
            >
              <div className={styles.titleContainer} onClick={(event) => handleOnClick(event, index)}>
                <div dangerouslySetInnerHTML={{ __html: question.html }} className={styles.question} />
                <div className={styles.accordionItemToggleContainer}>
                  <div className={styles.accordionItemToggle} />
                </div>
              </div>
              {answerHtml && <div className={styles.answer} dangerouslySetInnerHTML={{ __html: answerHtml }} />}
            </div>
          );
        })}
      </OnVisible>
      {!noSchema && <div dangerouslySetInnerHTML={{ __html: schema }} />}
    </Section>
  );
};

export default FaqAccordion;
